// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rxu8","colBig":"styles_colBig__STwhG","colSmall":"styles_colSmall__2p6kX","shopifyNameWrapper":"styles_shopifyNameWrapper__LDR4C"};